import { Route, Routes as BrowserRoutes } from "react-router-dom"

import Products from './products'
import { UI } from "components"
import Heading from "./heading"

export default function Store(){
    return(
    <>
    <UI.Header title="Loja" />

    <Heading />

    <BrowserRoutes>
        <Route index element={<Products />} />
    </BrowserRoutes>
    </>
    )
}